// REACT IMPORTS
import React, { useEffect, useState } from "react";

// CONTROLS IMPORTS
import { Box, TextField, Menu, MenuItem, Divider, IconButton, Grid,
    FormControl, InputLabel, Select, Typography, Button, Checkbox, FormControlLabel,
    Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import Rating from '@mui/material/Rating';

// ICONS IMPORTS
import CloseIcon from '@mui/icons-material/Close';

// REDUX IMPORTS
import { useDispatch, useSelector } from 'react-redux';
import { showWaiting, selectItem, showUserViewProfile } from '../../store/slices';
import { setstars, load } from '../../store/thunks/userAdminThunk';

// SERVICES
import { getUserProfileToView } from "../../services/profileService";

// LANGUAGE IMPORTS
import { useTranslation } from 'react-i18next';

// OWNED COMPONENTS IMPORTS
import { constants } from '../../util'



const UsersViewProfile = () => {
    // TRANSLATIONS
        const [t, i18n] = useTranslation("global");

    // LOCAL VARIABLES
    const leftColumnSize = 4;
    const rightColumnSize = 8;

    // LOCAL STATES
    const [scroll, setScroll] = useState('paper');
    const [userProfile, setUserProfile] = useState(null);
        
    
    // NEEDED HOOKS
    const dispatch = useDispatch();
    const { selectedId, openUserViewProfile } = useSelector(state => state.userAdmin);
    const { language } = useSelector(state => state.configuration);

    // EFFECTS
    useEffect(() => {
        if (selectedId !== -1 && selectedId !== null){
            dispatch(showWaiting(true));
            getUserProfileToView(selectedId?.toString())
                .then((rsp)=>{
                    setTimeout(() => {
                        if (rsp.code === '00'){
                            setUserProfile(
                                {
                                    nameArtist: rsp.metadata.nameArtist,
                                    email: rsp.metadata.email,
                                    company: rsp.metadata.company,
                                    originCountry: rsp.metadata.originCountry,
                                    countryName: rsp.metadata.countryName,
                                    phone: rsp.metadata.phone,
                                    urlTiktok: rsp.metadata.urlTiktok,
                                    urlYoutube: rsp.metadata.urlYoutube,
                                    urlInstagram: rsp.metadata.urlInstagram,
                                    urlFacebook: rsp.metadata.urlFacebook,
                                    urlSpotify: rsp.metadata.urlSpotify,
                                    urlApple: rsp.metadata.urlApple,
                                    biography: rsp.metadata.biography,
                                    cntStars: rsp.metadata.cntStars,
                                }
                            );
                        }
                        else {
                            enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                            handleClose();
                        }

                        dispatch(showWaiting(false));
                    }, 1000);
                });
        }
    }, [selectedId]);

    
    // LOCAL FUNCTIONS
    const handleClose = () => {
        setUserProfile(null);
        dispatch(selectItem(null));
        dispatch(showUserViewProfile(false));
    };

    const handleClick_Go = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    const handleClick_Set_Stars = (cntStars) => {
        if (cntStars!==null){
            dispatch(setstars(
                {
                    evaluatedUserId: selectedId.toString(),
                    grade: cntStars.toString()
                }
            ));

            setUserProfile({...userProfile, cntStars: cntStars})
        }
    }

    
    return (
        <>
            <Dialog
                open={openUserViewProfile}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth:'600px', overflow:'hidden', } }}
            >
                <DialogTitle id="scroll-dialog-title" sx={{fontSize:'16px', flex:'.1'}}>
                    {t("userView.titleViewProfile")}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers={scroll === 'paper'} sx={{ flex: .8, overflow: 'auto', }}>
                    <Grid container spacing={3} direction="column"> 
                        <Grid container size={12} direction="row">
                            <Grid size={leftColumnSize} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>{t("signUp.name")}</Grid>
                            <Grid size={rightColumnSize}>{userProfile?.nameArtist}</Grid>
                        </Grid>
                        <Grid container size={12} direction="row">
                            <Grid size={leftColumnSize} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>{t("signUp.company")}</Grid>
                            <Grid size={rightColumnSize}>{userProfile?.company}</Grid>
                        </Grid>
                        <Grid container size={12} direction="row">
                            <Grid size={leftColumnSize} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>{t("signUp.country")}</Grid>
                            <Grid size={rightColumnSize}>{userProfile?.countryName}</Grid>
                        </Grid>
                        <Grid container size={12} direction="row">
                            <Grid size={leftColumnSize} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>{t("userView.email")}</Grid>
                            <Grid size={rightColumnSize}>{userProfile?.email}</Grid>
                        </Grid>
                        <Grid container size={12} direction="row">
                            <Grid size={leftColumnSize} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>{t("signUp.phone")}</Grid>
                            <Grid size={rightColumnSize}>{userProfile?.phone}</Grid>
                        </Grid>
                        <Grid container size={12} direction="row">
                            <Grid size={leftColumnSize} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>Calificación</Grid>
                            <Grid >
                                <Rating name="size-large" value={userProfile?.cntStars || 0} size="large" max={5} 
                                    onChange={(event, newValue) => {
                                        handleClick_Set_Stars(newValue);
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container size={12} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>
                            {t("profile.title2")}
                        </Grid>
                        <Grid container size={12} sx={{fontWeight:'bold', color:'#667', display:'flex', justifyContent:'center', paddingLeft:'10%', paddingRight:'10%'}}>
                            {
                                userProfile!==null && userProfile?.urlSpotify !== null && userProfile?.urlSpotify !== ''
                                ? 
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => handleClick_Go(userProfile?.urlSpotify)}
                                    >
                                        <div style={{fontSize:'10px'}}>
                                        <img
                                            src="/assets/img/logo/spotity-c.png"
                                            alt="icon"
                                            style={{ width: 50, height: 50 }}
                                        /><br />
                                        Spotify
                                        </div>
                                    </IconButton>
                                : null
                            }
                            {
                                userProfile!==null && userProfile?.urlApple !== null && userProfile?.urlApple !== ''
                                ? 
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => handleClick_Go(userProfile?.urlApple)}
                                    >
                                        <div style={{fontSize:'10px'}}>
                                        <img
                                            src="/assets/img/logo/apple-c.png"
                                            alt="icon"
                                            style={{ width: 50, height: 50 }}
                                        /><br />
                                        Apple Music
                                        </div>
                                    </IconButton>
                                : null
                            }
                            {
                                userProfile!==null && userProfile?.urlTiktok !== null && userProfile?.urlTiktok !== ''
                                ? 
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => handleClick_Go(userProfile?.urlTiktok)}
                                    >
                                        <div style={{fontSize:'10px'}}>
                                        <img
                                            src="/assets/img/logo/tiktok-c.png"
                                            alt="icon"
                                            style={{ width: 50, height: 50 }}
                                        /><br />
                                        Tiktok
                                        </div>
                                    </IconButton>
                                : null
                            }
                            {
                                userProfile!==null && userProfile?.urlYoutube !== null && userProfile?.urlYoutube !== ''
                                ? 
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => handleClick_Go(userProfile?.urlYoutube)}
                                    >
                                        <div style={{fontSize:'10px'}}>
                                        <img
                                            src="/assets/img/logo/youtube.png"
                                            alt="icon"
                                            style={{ width: 50, height: 50 }}
                                        /><br />
                                        Youtube
                                        </div>
                                    </IconButton>
                                : null
                            }
                            {
                                userProfile!==null && userProfile?.urlInstagram !== null && userProfile?.urlInstagram !== ''
                                ? 
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => handleClick_Go(userProfile?.urlInstagram)}
                                    >
                                        <div style={{fontSize:'10px'}}>
                                        <img
                                            src="/assets/img/logo/instagram_color.png"
                                            alt="icon"
                                            style={{ width: 50, height: 50 }}
                                        /><br />
                                        Instagram
                                        </div>
                                    </IconButton>
                                : null
                            }
                            {
                                userProfile!==null && userProfile?.urlFacebook !== null && userProfile?.urlFacebook !== ''
                                ? 
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => handleClick_Go(userProfile?.urlFacebook)}
                                    >
                                        <div style={{fontSize:'10px'}}>
                                        <img
                                            src="/assets/img/logo/facebook_c.png"
                                            alt="icon"
                                            style={{ width: 50, height: 50 }}
                                        /><br />
                                        Facebook
                                        </div>
                                    </IconButton>
                                : null
                            }
                        </Grid>
                        <Grid container size={12} sx={{fontWeight:'bold', color:'#667', fontSize:'12px'}}>
                            {t("userView.biography")}
                        </Grid>
                        <Grid container size={12}>
                            <TextField multiline fullWidth minRows={5} maxRows={7}
                                variant="outlined" margin="normal"  
                                sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                value={userProfile?.biography}
                            />
                        </Grid>


                        {/* nameArtist: rsp.metadata.nameArtist,
                                    company: rsp.metadata.company,
                                    originCountry: rsp.metadata.originCountry,
                                    phone: rsp.metadata.phone,
                                    urlTiktok: rsp.metadata.urlTiktok,
                                    urlYoutube: rsp.metadata.urlYoutube,
                                    urlInstagram: rsp.metadata.urlInstagram,
                                    urlFacebook: rsp.metadata.urlFacebook,
                                    urlSpotify: rsp.metadata.urlSpotify,
                                    urlApple: rsp.metadata.urlApple,
                                    biography: rsp.metadata.biography */}
                    </Grid>
                    <div style={{flex:1}} />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default UsersViewProfile;